import { Dexie } from "dexie";
// src/createDatabase.ts
const name = "openphone-v3.0.0";
function createDatabase(databaseName = name) {
	const indexedDb = new Dexie(databaseName);
	indexedDb.version(1).stores({
		activity: "&id,conversationId,createdAt",
		blocklist: "&id",
		contact: "&id,*_phoneNumbers",
		contactSettings: "&id",
		contactTemplateItem: "&id",
		conversation: "&id,phoneNumber,phoneNumberId,directNumberId,lastActivityAt",
		directNumber: "&id",
		entityPhoneNumber: "&id",
		integration: "&id",
		integrationContact: "&id,*identifiers",
		kv: "",
		member: "&id",
		phoneNumber: "&id",
		presence: "&userId",
		snippet: "&id"
	});
	indexedDb.version(2).stores({ transaction: "&id" });
	indexedDb.version(3).stores({ alert: "&id" });
	indexedDb.version(4).stores({
		contact: "&id,*_phoneNumbers,sortName",
		conversation: "&id,phoneNumber,phoneNumberId,directNumberId,lastActivityAt,unreadCount"
	});
	indexedDb.version(5).stores({
		groups: "&id",
		webhooks: "&id"
	});
	indexedDb.version(6).stores({ contactGoogleSettings: "&id" });
	indexedDb.version(7).stores({ cnam: "&id" });
	indexedDb.version(8).stores({ contact: "&id,*_phoneNumbers,sortName,[source+sourceName]" });
	indexedDb.version(9).stores({ contact: "&id,*_phoneNumbers,sortName,[source+sourceName+userId]" });
	indexedDb.version(10).stores({ scheduledMessage: "&id,body.conversationId,body.activityId" });
	indexedDb.version(11).stores({ portRequest: "&id" });
	indexedDb.version(12).stores({ capability: "&type" });
	indexedDb.version(13).stores({ search: "&id" });
	indexedDb.version(14).stores({ ringOrder: "&id,&phoneNumberId" });
	indexedDb.version(15).stores({ csvImports: "&id" });
	indexedDb.version(16).stores({ tollFreeRegistration: "&id" });
	indexedDb.version(17).stores({ activity: "&id,conversationId,createdAt,[conversationId+createdAt]" });
	indexedDb.version(18).stores({ callFallbackConfig: "&id,&phoneNumberId" });
	indexedDb.version(19).stores({ tollFreeRegistrationLite: "&id" });
	indexedDb.version(20).stores({ contactSuggestion: "&id" });
	indexedDb.version(21).stores({ contact: "&id,*_phoneNumbers,sortName,[source+sourceName+userId],company" });
	indexedDb.version(22).stores({
		workflowDefinition: "&id",
		workflowStepDefinition: "&id",
		workflowTriggerDefinition: "&id"
	});
	indexedDb.version(23).stores({ tag: "&id,phoneNumberId" });
	indexedDb.version(24).stores({ ringOrder: "&id" });
	indexedDb.version(25).stores({
		addon: "&id",
		usage: "&name"
	});
	indexedDb.version(26).stores({ aiTriggerDefinition: "&id,entityId" });
	indexedDb.version(27).stores({ aiJobDefinition: "&id" });
	indexedDb.version(28).stores({ workflowStepDefinition: null });
	indexedDb.version(29).stores({ workflowStepDefinition: "&[id+version]" });
	indexedDb.version(30).stores({ addonTier: "&id,orgId,addonId" });
	indexedDb.version(31).stores({ aiJobDefinition: null });
	indexedDb.version(32).stores({ presence: null });
	indexedDb.version(33).stores({ contactSuggestion: null });
	indexedDb.version(34).stores({ workflowFilterDefinition: "&id" });
	indexedDb.version(35).stores({ scheduledMessage: null });
	indexedDb.version(36).stores({ search: null });
	indexedDb.version(37).stores({ workflowDefinitionCriteriaType: "&conditionId" });
	indexedDb.version(38).stores({ alert: null });
	indexedDb.version(39).stores({ integrationContact: null });
	return indexedDb;
}
export { createDatabase as default };

//# sourceMappingURL=createDatabase.js.map